import { ref, onBeforeUnmount, watch } from 'vue'
import {
	generateUniqueId,
	addOverlayListItem,
	removeOverlayListItem,
} from '@/legacy/ts/overlay'
import { checkIsKeyupEsc } from '@/lib/utils'

function useOverlay(
	props: any,
	updateModelValue: (value: boolean) => void,
	onHide?: () => void,
) {
	const isShow = ref(false)
	const uniqueId = generateUniqueId()

	const show = () => {
		isShow.value = true
		updateModelValue(true)
		addOverlayListItem(uniqueId)
		freezeBodyScroll()
		document.addEventListener('keyup', pressESC)
	}
	const hide = () => {
		isShow.value = false
		updateModelValue(false)
		if (onHide) {
			onHide()
		}
		removeOverlayListItem(uniqueId)
		liberateBodyScroll()
		document.removeEventListener('keyup', pressESC)
	}
	const destroy = () => {
		isShow.value = false
		updateModelValue(false)
		removeOverlayListItem(uniqueId)
		liberateBodyScroll()
		document.removeEventListener('keyup', pressESC)
	}

	function pressESC(evt: KeyboardEvent) {
		if (checkIsKeyupEsc(evt)) {
			isShow.value = false
		}
	}

	function freezeBodyScroll() {
		addOverlayListItem(uniqueId)
	}

	function liberateBodyScroll() {
		removeOverlayListItem(uniqueId)
	}

	onBeforeUnmount(() => {
		destroy()
	})

	watch(
		() => isShow.value,
		val => {
			if (val) show()
			else hide()
		},
		{
			// immediate: true,
		},
	)

	watch(
		() => props.modelValue,
		val => {
			isShow.value = val
		},
		{
			immediate: true,
		},
	)

	return {
		isShow,
		uniqueId,
		show,
		hide,
		destroy,
		freezeBodyScroll,
		liberateBodyScroll,
	}
}

export default useOverlay
